export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [50, 100, 150, 200];

export const defaultPageNumber = 1;
export const defaultPageSize = 50;
